var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHintClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M12.8322 2.91558C13.178 2.56981 13.7385 2.56981 14.0843 2.91558C14.43 3.26136 14.43 3.82186 14.0843 4.16762L9.75197 8.49993L14.0843 12.8322C14.43 13.178 14.43 13.7385 14.0843 14.0843C13.7385 14.43 13.178 14.43 12.8322 14.0843L8.49993 9.75197L4.16762 14.0843C3.82186 14.43 3.26136 14.43 2.91558 14.0843C2.56981 13.7385 2.56981 13.178 2.91558 12.8322L7.2479 8.49993L2.91558 4.16762C2.56981 3.82184 2.56981 3.26136 2.91558 2.91558C3.26136 2.56981 3.82184 2.56981 4.16762 2.91558L8.49993 7.2479L12.8322 2.91558Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHintClose);
export default __webpack_public_path__ + "static/media/hint-close.e9165f8f2dbbdbdef75223c9487d109b.svg";
export { ForwardRef as ReactComponent };